import { Divider, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getCountryDetails } from "../../pages/Profile/actions";
import ErrorMessage from "../../utils/ErrorMessage";
import { profileDataValidation, validateName } from "../../utils/Functions";
import SelectDropdown from "../SelectDropdown/SelectDropdown";
import {
  ProfileCancelButton,
  ProfileEditButton,
  ProfileSaveButton,
} from "./ProfileButtons";

const AddressDetail = ({
  addressDetails,
  showInput,
  handleShowInput,
  handleUpdate,
  isGuest,
  addressdetails,
  setaddressDetails,
  errors,
  setErrors,
}) => {
  const dispatch = useDispatch();
  const countryList = useSelector((state) => state.profile.countryList);
  const loading = useSelector((state) => state.profile.loading);
  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    dispatch(getCountryDetails());
  }, []);
  useEffect(() => {
    if (!isGuest) {
      setaddressDetails({
        ...addressDetails,
        country: {
          label: addressDetails?.country,
          value: addressDetails?.country,
        },
      });
    }
  }, [addressDetails]);

  useEffect(() => {
    let countryArray = [];
    countryList.length > 0 &&
      countryList.map((country) =>
        countryArray.push({
          label: country.countryName,
          value: country.countryName,
        })
      );

    setCountryOptions(countryArray);
  }, [countryList]);
  return (
    <>
      <div className={`panel-header pt-0 ${isGuest ? "sec-head" : ""}`} id="section-address">
        {isGuest && <div className="sec-num">3</div>}
        <div className="title">Address Details</div>
      </div>
      <div className="panel-content pt-0">
        <Row>
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group">
                <label className="form-label">Street</label>
                {!isGuest && !showInput.street && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(addressdetails?.street)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("street");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.street) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="text"
                      value={addressdetails.street}
                      onChange={(e) => {
                        setaddressDetails({
                          ...addressdetails,
                          street: e.target.value,
                        });
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            handleUpdate("street", addressdetails.street);
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("street");
                            setaddressDetails({
                              ...addressdetails,
                              street: addressDetails.street,
                            });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </Col>
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group">
                <label className="form-label">ZIP/Postal Code</label>
                {!isGuest && !showInput.zipCode && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(addressdetails?.postalCode)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("zipCode");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.zipCode) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="number"
                      className={"no-spinners"}
                      value={addressdetails.postalCode}
                      onChange={(e) => {
                        setaddressDetails({
                          ...addressdetails,
                          postalCode: e.target.value,
                        });
                      }}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(evt) => {
                        if (evt.keyCode === 38 || evt.keyCode === 40) {
                          evt.preventDefault(); // prevent default behavior of arrow keys
                        }
                        ["e", "E", "+", "-"].includes(evt.key) &&
                          evt.preventDefault();
                      }}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 6))
                      }
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            handleUpdate("zipCode", addressdetails.postalCode);
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("zipCode");
                            setaddressDetails({
                              ...addressdetails,
                              postalCode: addressDetails.postalCode,
                            });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </Col>
          <Col md={4} sm={6}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-city">
                <label className="form-label">
                  City<span className="text-danger"> *</span>
                </label>
                {!isGuest && !showInput.city && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(addressdetails?.city)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("city");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.city) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="text"
                      value={addressdetails.city}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length > 0 && inputValue[0] === " ") {
                          return;
                        }
                        setaddressDetails({
                          ...addressdetails,
                          city: inputValue,
                        });
                        if (inputValue === "") {
                          setErrors({
                            ...errors,
                            city: ErrorMessage.PROVIDE_CITY,
                          });
                        } else if (!validateName(inputValue)) {
                          setErrors({
                            ...errors,
                            city: ErrorMessage.PROVIDE_VALID_CITY,
                          });
                        } else {
                          setErrors({
                            ...errors,
                            city: "",
                          });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!addressdetails.city.trim()) {
                              setErrors({
                                ...errors,
                                city: ErrorMessage.PROVIDE_CITY,
                              });
                            } else {
                              setErrors({ ...errors, city: "" });
                              handleUpdate("city", addressdetails.city);
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("city");
                            setaddressDetails({
                              ...addressdetails,
                              city: addressDetails.city,
                            });
                            setErrors({ ...errors, city: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.city}</span>
              </div>
            )}
          </Col>

          <Col sm={4}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group">
                <label className="form-label">State/Province</label>
                {!isGuest && !showInput.state && (
                  <div className="edit-profile-input">
                    <h6 className="mt-1 text-title cursor-pencil">
                      {profileDataValidation(addressdetails?.state)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("state");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.state) && (
                  <div className="edit-inline-action">
                    <Form.Control
                      type="text"
                      value={addressdetails.state}
                      onChange={(e) => {
                        setaddressDetails({
                          ...addressdetails,
                          state: e.target.value,
                        });
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            handleUpdate("state", addressdetails.state);
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("state");
                            setaddressDetails({
                              ...addressdetails,
                              state: addressDetails.state,
                            });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </Col>
          <Col sm={4}>
            {loading && <Skeleton active paragraph={{ rows: 2 }} />}
            {!loading && (
              <div className="form-group" id="field-country">
                <label className="form-label">
                  Country<span className="text-danger"> *</span>
                </label>
                {!isGuest && !showInput.country && (
                  <div className="edit-profile-input">
                    <h6
                      className="mt-1 text-title cursor-pencil"
                      onClick={() => handleShowInput("country")}
                    >
                      {profileDataValidation(addressdetails?.country?.label)}
                    </h6>
                    <ProfileEditButton
                      onClick={() => {
                        handleShowInput("country");
                      }}
                    />
                  </div>
                )}
                {(isGuest || showInput.country) && (
                  <div className="edit-inline-action">
                    <SelectDropdown
                      placeholder="Select country"
                      options={countryOptions}
                      // Controlled `value` so CV auto-fill (e.g. India) shows up after parse
                      value={
                        addressdetails?.country?.label
                          ? {
                            label: addressdetails.country.label,
                            value: addressdetails.country.value,
                          }
                          : undefined
                      }
                      onValueChange={(e) => {
                        if (e === undefined) {
                          setaddressDetails({
                            ...addressdetails,
                            country: "",
                          });
                        } else {
                          setaddressDetails({
                            ...addressdetails,
                            country: e,
                          });
                          setErrors({ ...errors, country: "" });
                        }
                      }}
                    />
                    {!isGuest && (
                      <>
                        <ProfileSaveButton
                          onClick={() => {
                            if (!addressdetails.country.value) {
                              setErrors({
                                ...errors,
                                country: ErrorMessage.PROVIDE_COUNTRY,
                              });
                            } else {
                              setErrors({
                                ...errors,
                                country: "",
                              });
                              handleUpdate(
                                "country",
                                addressdetails.country.value
                              );
                            }
                          }}
                        />
                        <ProfileCancelButton
                          onClick={() => {
                            handleShowInput("country");
                            setaddressDetails({
                              ...addressdetails,
                              country: {
                                label: addressDetails?.country,
                                value: addressDetails?.country,
                              },
                            });
                            setErrors({ ...errors, country: "" });
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
                <span className="text-error">{errors.country}</span>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddressDetail;
